import React from "react";
import variables from "Assets/style/variablesExport.module.scss";
import CapacityBar from "./CapacityBar/CapacityBar";

type AnalysisUsageBarProps = {
  portalUsage: number;
  cliUsage: number;
  totalCapacity: number;
};

export const AnalysisUsageBar = ({
  portalUsage,
  cliUsage,
  totalCapacity,
}: AnalysisUsageBarProps): React.JSX.Element => {
  const usages = [
    {
      name: "CLI",
      used: cliUsage,
      color: variables.cli_usage_fill_color,
    },
    {
      name: "Portal",
      used: portalUsage,
      color: variables.portal_usage_fill_color,
    },
  ];

  return (
    <CapacityBar
      totalCapacity={totalCapacity}
      usages={usages}
      unit="GB"
      showLegend={true}
    />
  );
};

export default AnalysisUsageBar;
